import { useQuery } from "@tanstack/react-query";
import {
  fetchTravelClaims,
  fetchTravelClaimsV2,
} from "../services/travelClaims";
import { ClaimListFilters, ClaimStatuses } from "../types/travelClaims";

export const useTravelClaimsQuery = (
  status: ClaimStatuses | null,
  ordering: {},
  search: string = "",
  filters: ClaimListFilters | undefined,
  page: number = 1
) => {
  return useQuery({
    refetchOnWindowFocus: false, // Optional: Disable automatic refetch on window focus
    queryKey: ["travelClaims", status, ordering, search, filters, page],
    queryFn: () => fetchTravelClaims(status, ordering, search, filters, page),
  });
};

export const useTravelClaimsQueryV2 = (
  status: ClaimStatuses[] | null,
  ordering: {},
  search: string = "",
  filters: ClaimListFilters | undefined,
  page: number = 1,
  limit: number | null = null
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["travelClaims", status, ordering, search, filters, page],
    queryFn: () =>
      fetchTravelClaimsV2(status, ordering, search, filters, page, limit),
    retry: 0, // Кол-во повторных попыток после ошибки
  });
};
